export default __webpack_public_path__ + "static/media/bg_logo.c9e7e403.png";